//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect.vue'
import SearchInput from '@/components/SearchInput.vue'
import ProductosApi from "@/api/promotores/productos.api";
import productosApi from "@/api/promotores/productos.api";



export default {
  components: { ColumnsSelect, SearchInput },
  data() {
    return {
      visible_columns: [
         'nombre_completo', 'correo', 'created_at', 'promotor', 'col_detalle','estatus'
      ],
      columns: [
        { name: "nombre_completo", label: "Nombre", field: "nombre_completo", sortable: true, align: "left" },
        { name: "correo", label: "Correo electrónico", field: "correo", sortable: true, align: "left" },
        { name: 'promotor', field: '', label: 'Promotor', sortable: true, align: 'left' },
        { name: "created_at", label: "Fecha de creación", field: "created_at", sortable: true, align: "left" },
        { name: "estatus", label: "Estatus", field: "estatus", sortable: true, align: "left" },
				{ name: 'col_detalle', field: '', label: 'Detalle', sortable: false, align: 'left' },
      ],
      solicitudes: [],
      status: [
        { value: 'en_proceso_cesion', label: 'En proceso de cesión' },
        { value: 'aprobado', label: 'Aprobado' },
        { value: 'cancelado', label: 'Cancelado' },
      ],
      loading: false,
      filter: null,
      producto: null
    }
  },

  mounted() {

    this.producto = this.$route.params.producto;

    this.loadSolicitudes()
  },

  computed:{
    nombre_producto() {
     switch (this.producto) {
       case 'flex':
         return 'Flex'
       case 'libre':
         return 'Libre'
       case 'anticipo_venta':
           return 'Anticipo a la venta'
       default:
         return ''
     }
    }
  },

  methods: {
    async loadSolicitudes() {
      this.solicitudes = []
      try {
        this.loading = true
        this.solicitudes = await ProductosApi.solicitudes(this.producto)
      } finally {
        this.loading = false
      }
    },

    async updateStatus(solicitud) {
      try {
        this.loading = true

        const resp = await ProductosApi.solicitud_estatus(this.producto, solicitud._id, { estatus: solicitud.estatus })

        this.$q.notify({
          message: `Estatus actualizado`,
          type: "positive",
          position: "top-right",
        });

        await this.loadSolicitudes()

        this.loading = false

      } catch (e) {

        //Solo se muestra el dialogó de error si el error no es de validación
        let dialogo_error = !e.response && e.response.code === 422

        if (dialogo_error)
          this.$q.dialog({
            title: "Ocurrio un error al editar estatus de la solicitud",
            message: "Intente mas tarde, si el problema persiste favor de contactar a soporte.",
            html: true,
            ok: {
              push: true,
            },
            persistent: true,

          }).onOk(() => {
            this.loading = false
          })

      }

    }
  }

  ,watch:{
    $route (to, from){
      if (this.producto !== to.params.producto)
        this.producto = to.params.producto
        this.loadSolicitudes()
    }
  }
}
